import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { filter, map, mergeMap, takeUntil } from 'rxjs/operators';

import { User } from '../../../../models/user';
import { UserService } from '../../../../services/user.service';

interface ManageViewModel {
  users: User[];
}

@Component({
  selector: 'app-manage',
  templateUrl: './manage.page.html',
  styleUrls: ['./manage.page.scss'],
})
export class ManagePage implements OnInit, OnDestroy {

  viewModel: ManageViewModel;
  searchTerms$ = new BehaviorSubject<string>(null);

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private userService: UserService
  ) { }

  ngOnInit() {
    this.searchTerms$
      .pipe(
        takeUntil(this.destroyed$),
        filter(terms => !!terms),
        mergeMap(terms => this.userService.searchUsers(terms)),
        map(result => ({ users: result.items }))
      )
      .subscribe(viewModel => {
        this.viewModel = viewModel;
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onSearchInputChange(event: Event) {
    const value = (event as CustomEvent).detail.value;
    this.searchTerms$.next(value);
  }

  mockLoadingItems(count: number) {
    return new Array(count);
  }
}
